export const GlueWebPlatformControlName = "T42.Web.Platform.Control";

export const GlueWebPlatformStreamName = "T42.Web.Platform.Stream";

export const GlueClientControlName = "T42.Web.Client.Control";

export const GlueCorePlusThemesStream = "T42.Core.Plus.Themes.Stream";